/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1Predicate } from './V2beta1Predicate';
import {
  V2beta1PredicateFromJSON,
  V2beta1PredicateFromJSONTyped,
  V2beta1PredicateToJSON,
  V2beta1PredicateToJSONTyped,
} from './V2beta1Predicate';

/**
 * Filter is used to filter resources returned from a ListXXX request.
 *
 * Example filters:
 * 1) Filter runs with status = 'Running'
 * filter {
 *   predicate {
 *     key: "status"
 *     operation: EQUALS
 *     string_value: "Running"
 *   }
 * }
 *
 * 2) Filter runs that succeeded since Dec 1, 2018
 * filter {
 *   predicate {
 *     key: "status"
 *     operation: EQUALS
 *     string_value: "Succeeded"
 *   }
 *   predicate {
 *     key: "created_at"
 *     operation: GREATER_THAN
 *     timestamp_value {
 *       seconds: 1543651200
 *     }
 *   }
 * }
 *
 * 3) Filter runs with one of labels 'label_1' or 'label_2'
 *
 * filter {
 *   predicate {
 *     key: "label"
 *     operation: IN
 *     string_values {
 *       value: 'label_1'
 *       value: 'label_2'
 *     }
 *   }
 * }
 * @export
 * @interface V2beta1Filter
 */
export interface V2beta1Filter {
  /**
   * All predicates are AND-ed when this filter is applied.
   * @type {Array<V2beta1Predicate>}
   * @memberof V2beta1Filter
   */
  predicates?: Array<V2beta1Predicate>;
}

/**
 * Check if a given object implements the V2beta1Filter interface.
 */
export function instanceOfV2beta1Filter(value: object): value is V2beta1Filter {
  return true;
}

export function V2beta1FilterFromJSON(json: any): V2beta1Filter {
  return V2beta1FilterFromJSONTyped(json, false);
}

export function V2beta1FilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): V2beta1Filter {
  if (json == null) {
    return json;
  }
  return {
    predicates:
      json['predicates'] == null
        ? undefined
        : (json['predicates'] as Array<any>).map(V2beta1PredicateFromJSON),
  };
}

export function V2beta1FilterToJSON(json: any): V2beta1Filter {
  return V2beta1FilterToJSONTyped(json, false);
}

export function V2beta1FilterToJSONTyped(
  value?: V2beta1Filter | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    predicates:
      value['predicates'] == null
        ? undefined
        : (value['predicates'] as Array<any>).map(V2beta1PredicateToJSON),
  };
}
